import classNames from 'classnames'
import { Dispatch, SetStateAction, useEffect, useRef } from 'react'

export const OptionsTabs: React.FC<{
  options: {
    /** 文字内容 */
    label: React.ReactNode
    /** 展示new标 */
    isNew?: boolean
  }[]
  currentIndex: number
  setCurrentIndex: Dispatch<SetStateAction<number>>
  onChange?: (index: number) => void
  className?: string
}> = ({ options, currentIndex, setCurrentIndex, onChange, className }) => {
  const tabRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    /** 当前元素与页面左侧的原始距离（包括滚动距离） */
    const currentLeft =
      Number(
        tabRef.current?.children[currentIndex].getBoundingClientRect().left
      ) + Number(tabRef.current?.scrollLeft)

    /** 当前元素的宽度 */
    const currentWidth = Number(
      tabRef.current?.children[currentIndex].getBoundingClientRect().width
    )
    /** 父元素与页面左侧的距离 */
    const parentLeft = Number(tabRef.current?.getBoundingClientRect().left)
    /** 父元素的宽度 */
    const parentWidth = Number(tabRef.current?.offsetWidth)

    /** 让当前元素尽可能显示在Tabs中间 */
    tabRef.current?.scrollTo({
      left: currentLeft - parentLeft + currentWidth / 2 - parentWidth / 2,
      behavior: 'smooth',
    })
  }, [currentIndex])

  return (
    <div
      ref={tabRef}
      className={classNames(
        'flex items-center mb-4 border-b-[1px] border-neutral-300 overflow-x-auto scrollbar-hidden',
        className
      )}
    >
      {options.map((item, index) => {
        const isActive = currentIndex === index
        return (
          <div
            key={index}
            className={classNames(
              'relative flex-shrink-0 whitespace-nowrap py-2 text-sm font-semibold hover:text-neutral-900 cursor-pointer transition-all',
              [isActive ? 'text-neutral-900' : 'text-neutral-400'],
              {
                'ml-7': index > 0,
              }
            )}
            onClick={() => {
              if (isActive) return
              setCurrentIndex(index)
              onChange?.(index)
            }}
          >
            {item?.isNew && (
              <img
                className="h-[14px] absolute top-0 -right-3"
                src="/images/ai/new.png"
                alt=""
              />
            )}
            {item?.label}
            {isActive && (
              <span className="absolute bottom-0 left-0 right-0 mx-auto max-w-[24px] h-0.5 bg-primary"></span>
            )}
          </div>
        )
      })}
    </div>
  )
}
